import type { FC } from 'react';
import parse from 'html-react-parser';

import { cn } from '@/lib/utils';

import { Card, type CardProps } from '@/components/atoms/Card';
import { P } from '@/components/atoms/Typography/P';

export interface ReviewCardTemplateProps extends Omit<CardProps, 'children'> {
    name: string;
    rating: string | number;
    content: string;
}

const ReviewCardTemplate: FC<ReviewCardTemplateProps> = ({
    name,
    rating,
    content,
    className,
    ...cardProps
}) => (
    <Card
        size="l"
        variant="shadow"
        className={cn(
            'mx-1 my-4 flex h-full w-fit max-w-[320px] flex-col justify-between gap-4 self-stretch lg:m-0 lg:max-w-full',
            className,
        )}
        {...cardProps}
    >
        <P className={'self-stretch text-grey-600'}>{parse(content)}</P>

        <div className="flex w-full items-center justify-between">
            <p className="font-black text-typo-primary">{name}</p>

            <span className="text-md font-black text-green-500 lg:text-xl">
                {rating}
            </span>
        </div>
    </Card>
);

export default ReviewCardTemplate;
